/**
 * @generated SignedSource<<33c9c130863a4a65ac47546ec909c384>>
 * @relayHash e24c5363d85397ffd09961b0158238e9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 82578073483388cff5bdf8623eae547a9626c4c2f7b4c3a49c72a4eeb8c73f49

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AgentStudioSkillsQuery$variables = {
  cloudId: string;
  contextAri: string;
  isStudioCustomSkillsM1FrontendEnabled: boolean;
};
export type AgentStudioSkillsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SkillsFilter_AtlassianAgentStudioSkills_fragmentRef" | "SkillsList_AtlassianAgentStudioSkills_fragmentRef">;
};
export type AgentStudioSkillsQuery = {
  response: AgentStudioSkillsQuery$data;
  variables: AgentStudioSkillsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contextAri"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isStudioCustomSkillsM1FrontendEnabled"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = {
  "kind": "Variable",
  "name": "contextAri",
  "variableName": "contextAri"
},
v3 = [
  (v1/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  },
  {
    "items": [
      {
        "kind": "Literal",
        "name": "relevantFor.0",
        "value": "PLATFORM_SKILL"
      }
    ],
    "kind": "ListValue",
    "name": "relevantFor"
  },
  {
    "kind": "Literal",
    "name": "surface",
    "value": "ROVO_AGENTS"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "name"
},
v7 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v8 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v9 = [
  (v5/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "AgentStudioSkillsQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          {
            "kind": "Variable",
            "name": "isStudioCustomSkillsM1FrontendEnabled",
            "variableName": "isStudioCustomSkillsM1FrontendEnabled"
          }
        ],
        "kind": "FragmentSpread",
        "name": "SkillsList_AtlassianAgentStudioSkills_fragmentRef"
      },
      {
        "args": [
          (v2/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "SkillsFilter_AtlassianAgentStudioSkills_fragmentRef"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AgentStudioSkillsQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "GraphIntegrationDirectoryItemConnection",
        "kind": "LinkedField",
        "name": "graphIntegration_componentDirectoryItems",
        "plural": false,
        "selections": [
          {
            "concreteType": "GraphIntegrationDirectoryItemEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "description"
                      },
                      {
                        "concreteType": "GraphIntegrationSkillUiMetadata",
                        "kind": "LinkedField",
                        "name": "uiMetadata",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "color"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "iconKey"
                          },
                          (v7/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "GraphIntegrationSkillMetadata",
                        "kind": "LinkedField",
                        "name": "metadata",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "tags"
                          },
                          {
                            "concreteType": "GraphIntegrationSkillTool",
                            "kind": "LinkedField",
                            "name": "tools",
                            "plural": true,
                            "selections": [
                              (v5/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "source"
                              }
                            ]
                          },
                          {
                            "condition": "isStudioCustomSkillsM1FrontendEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "createdBy",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  (v8/*: any*/),
                                  (v6/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "picture"
                                  },
                                  (v5/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ],
                    "type": "GraphIntegrationSkillItem"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v9/*: any*/),
                    "type": "GraphIntegrationActionDirectoryItem"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v9/*: any*/),
                    "type": "GraphIntegrationMcpServer"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v9/*: any*/),
                    "type": "GraphIntegrationMcpTool"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v9/*: any*/),
                    "type": "GraphIntegrationSkillDirectoryItem"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "endCursor"
              },
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              }
            ]
          }
        ]
      },
      {
        "args": (v3/*: any*/),
        "filters": [
          "cloudId",
          "relevantFor",
          "surface",
          "searchKeyword",
          "dimensionIds"
        ],
        "handle": "connection",
        "key": "SkillsList_AtlassianAgentStudioSkills_graphIntegration_componentDirectoryItems",
        "kind": "LinkedHandle",
        "name": "graphIntegration_componentDirectoryItems"
      },
      {
        "condition": "isStudioCustomSkillsM1FrontendEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "AuthenticationContext",
            "kind": "LinkedField",
            "name": "me",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v8/*: any*/),
                  (v5/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "args": [
          (v2/*: any*/),
          {
            "kind": "Literal",
            "name": "dimension",
            "value": "PRODUCTS"
          }
        ],
        "concreteType": "GraphIntegrationSkillDimensionMetadata",
        "kind": "LinkedField",
        "name": "graphIntegration_skillDimensionMetadata",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v7/*: any*/),
              (v5/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "iconUrl"
                  }
                ],
                "type": "GraphIntegrationSkillProductItem"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "82578073483388cff5bdf8623eae547a9626c4c2f7b4c3a49c72a4eeb8c73f49",
    "metadata": {},
    "name": "AgentStudioSkillsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "1f6102576d190ca076f2ebfc79876b73";

export default node;
